import React, { FC, useContext, useEffect } from 'react';
import './App.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import HeaderBox from './components/HeaderBox/HeaderBox';
import ContentBox from './components/ContentBox/ContentBox';
import FooterBox from './components/FooterBox/FooterBox';
import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { Context } from './index';

export const App: FC = () => {
  const { store } = useContext(Context);

  useEffect(() => {
    if (localStorage.getItem('refresh_token')) {
      store.checkAuth().then();
    }
  });
  return (
    <div className="App">
      <Router>
        <Layout className="layout">
          <HeaderBox />
          <ContentBox />
          <FooterBox />
        </Layout>
      </Router>
    </div>
  );
};

export default observer(App);
